<div class="template">
    Error 404 <br />
    Something has gone wrong!
</div>